module.exports = __webpack_public_path__ + "img/4.39275deb.png";